module.exports = __webpack_public_path__ + "img/Hongkong-5.90822425.jpg";